module.exports = __webpack_public_path__ + "static/desktop/img/iPastBook-logo-purple.022e76f8.svg";